import { Component } from '@angular/core';


@Component({
  selector: 'svg-loader',
  template: require('./loader.component.html')
})
export class SvgLoaderComponent {
}
